import useSwr from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { VendorUser } from '~/models/VendorUser';

const paths = {
  index: '/vendors/vendor_users'
};
type TIndex = () => SwrReturnType<VendorUser[]>;

type ReturnType = {
  index: TIndex;
};

export const useVendorUsers = (): ReturnType => {
  const index: TIndex = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSwr<VendorUser[]>(paths.index);
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
